const merchant = {
  state: {
    tabIndex: '1', // 选中的选项卡
    tabIndexRole: 0,
    tabIndexMenu: 0,
  },
  getters: {
    // getPayProduct: (state) => (username) => {
    //
    //   // return sessionStorage.getItem('payProduct')
    //   // return this.$cookies.get('userName')
    // }
  },
  mutations: {

  },
  actions: {

  },
};

export default merchant;
